"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPopup,
  DialogTitle,
} from "@/app/_components/ui/Dialog";

interface ContactConfirmationDialogProps {
  status: "success" | "error";
  open: boolean;
  contactEmail: string;
  contactPhone: string;
  formData: {
    fname: string;
    email: string;
    phone: string;
    comment: string;
  };
  onCorrectData: () => void;
  onOpenChange: (open: boolean) => void;
}

export function ContactConfirmationDialog({
  status,
  open,
  contactEmail,
  contactPhone,
  formData,
  onCorrectData,
  onOpenChange,
}: ContactConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPopup>
        <DialogHeader>
          <DialogTitle>
            {status === "error"
              ? "Failed to send message"
              : "Message sent successfully"}
          </DialogTitle>
        </DialogHeader>

        <DialogContent>
          {status === "error" ? (
            <p>
              An error occurred while sending your message. Please try again.
            </p>
          ) : (
            <>
              <DialogDescription>Thank you for reaching out!</DialogDescription>

              <p>
                Your local equipment specialist will be contacting you typically
                within 1 business day to discuss your goals.
              </p>

              <div className="contact-dialog-details">
                <p className="contact-dialog-details__title">
                  Please take a moment to review your submitted information:
                </p>

                <dl className="contact-dialog-details__list">
                  <div className="contact-dialog-details__item">
                    <dt>Full Name:</dt>
                    <dd>{formData.fname}</dd>
                  </div>

                  <div className="contact-dialog-details__item">
                    <dt>Email:</dt>
                    <dd>{formData.email}</dd>
                  </div>

                  <div className="contact-dialog-details__item">
                    <dt>Phone:</dt>
                    <dd>{formData.phone}</dd>
                  </div>

                  <div className="contact-dialog-details__item">
                    <dt>Message:</dt>
                    <dd>{formData.comment}</dd>
                  </div>
                </dl>
              </div>
            </>
          )}

          <div className="contact-dialog-note">
            <p className="contact-dialog-note__title">
              {status === "error"
                ? "If the issue persists, please contact us via phone or email:"
                : "If you notice any discrepancies please contact us via phone or email:"}
            </p>

            <ul className="contact-dialog-note__list">
              <li>
                Phone:
                <a href={`tel:${contactPhone}`}>{contactPhone}</a>
              </li>

              <li className="contact-dialog-note__item">
                Email:
                <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
              </li>
            </ul>
          </div>

          <DialogFooter>
            {status === "error" ? (
              <button onClick={onCorrectData}>Try again</button>
            ) : (
              <>
                <button onClick={onCorrectData}>Correct data</button>
                <button onClick={() => onOpenChange(false)}>Continue</button>
              </>
            )}
          </DialogFooter>
        </DialogContent>
      </DialogPopup>
    </Dialog>
  );
}
